var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 4.58337C3.55888 4.58337 2.97598 4.82482 2.54621 5.25459C2.11644 5.68436 1.875 6.26725 1.875 6.87504V13.125C1.875 13.7328 2.11644 14.3157 2.54621 14.7455C2.97598 15.1753 3.55888 15.4167 4.16667 15.4167H11.25C11.8578 15.4167 12.4407 15.1753 12.8705 14.7455C13.3002 14.3157 13.5417 13.7328 13.5417 13.125V11.7967L16.3908 14.3342C17.0617 14.9317 18.125 14.455 18.125 13.5559V6.13754C18.125 5.23754 17.0617 4.76171 16.3908 5.35921L13.5417 7.89671V6.87504C13.5417 6.26725 13.3002 5.68436 12.8705 5.25459C12.4407 4.82482 11.8578 4.58337 11.25 4.58337H4.16667Z",
    fill: "#ECB32C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.b4bd966c313c8ff7e4771b9baed0b3e5.svg";
export { ForwardRef as ReactComponent };